import { render, staticRenderFns } from "./ProfileEditPhone.vue?vue&type=template&id=01086f7f"
import script from "./ProfileEditPhone.vue?vue&type=script&lang=js"
export * from "./ProfileEditPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports